import _ from 'lodash';
import V from 'voca';

const filterExercises = function (
  exercises,
  searchTerm,
  unparsedfavorites,
  favoritesSelected,
  tags
) {
  const favorites = parseFavorites(unparsedfavorites);
  const favList = [...favorites];

  exercises.forEach(item => {
    if (favList.some(ex => ex.id === item.id)) {
      const index = favList.findIndex(ex => ex.id === item.id);
      favList.splice(index, 1, {
        ...item,
        ...favList[index]
      });
    }
  });

  if (tags && tags.length > 0) {
    /**
     * Show filter results and add/remove favorites
     */
    return checkDupes(favoritesSelected, exercises, favList);
  }

  if (favoritesSelected) {
    if (!searchTerm || searchTerm === 'NONE') {
      return favList;
    }
    /**
     * Show all favorites, remove non-favorites
     */

    return pull(favList, searchTerm);
  } else {
    if (!searchTerm || searchTerm === 'NONE') {
      return combine(favList, exercises);
    }

    if (!exercises || exercises.length === 0) {
      return exercises;
    }

    /**
     * Combine all favorites and returned exercises
     */
    return combine(pull(favList, searchTerm), exercises);
  }
};

/**
 * Remove isSelected
 * @param exercises
 * @returns {*}
 */
export const clearSelected = exercises =>
  exercises.map(ex => {
    const dupe = { ...ex };
    dupe.isSelected = false;
    return dupe;
  });

/**
 * Return Exercises without Favorites
 * @param tags
 * @param exercises
 * @param favorites
 * @returns {*}
 */
const checkDupes = (favoritesSelected, uncompactedExercises, favorites) => {
  const exercises = _.compact(uncompactedExercises);

  //favorites selected & no favorites
  if (favoritesSelected && favorites.length === 0) {
    return [];
  }

  //no favorites
  if (favorites.length === 0 || exercises.length === 0) {
    return exercises;
  }
  //favorites added - need to remove duplicates
  const foundFavorites = [];
  //iterate through favorites, check to see if it is present.
  // Remove exercises that are present and add them to found favorites

  for (let i = 0; i < favorites.length; i++) {
    const id = favorites[i].id;

    for (let j = 0; j < exercises.length; j++) {
      const exercise = exercises[j];

      if (exercise && exercise.id === id) {
        exercises[j] = null;
        foundFavorites.push(favorites[i]);
      }
    }
  }
  //if only show favorites, only return favorites present in exercises
  if (favoritesSelected) {
    return foundFavorites;
  }
  //else combine favorites first to exercises list, and
  //remove falsey values from exercises and return found favorites
  const exs = _.compact(exercises);
  return [...foundFavorites, ...exs];
};

/**
 * Return list of favorites with search term
 * @param favorites
 * @param searchTerm
 * @returns {*}
 */
const pull = (favorites, searchTerm) =>
  _.filter(favorites, o => {
    try {
      return o.exerciseName.includes(searchTerm) || o.tag.includes(searchTerm);
    } catch (err) {
      return false;
    }
  });

/**
 * Combine favorites and exercises
 * @param favorites
 * @param exercises
 * @returns {*}
 */
const combine = (favorites, exercises) => {
  const keys = [];

  if (favorites.length === 0) {
    return exercises;
  }

  for (let i = 0; i < favorites.length; i++) {
    keys.push(favorites[i].id);
  }

  const pulled = _.filter(exercises, o => {
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key === o.id) {
        return false;
      }
    }
    return true;
  });

  return [...favorites, ...pulled];
};
/**
 * Transform favorites array to be client readable
 * @param favoritesArray
 * @returns {Array}
 */
export const parseFavorites = favoritesArray => {
  if (!favoritesArray || favoritesArray.length === 0) {
    return [];
  }
  const parsedArray = [];

  for (let i = 0; i < favoritesArray.length; i++) {
    const favorite = favoritesArray[i];

    const parsed = _.mapKeys(favorite, (v, k) => {
      return V.camelCase(k);
    });
    parsed.star = true;
    parsedArray.push(parsed);
  }

  return parsedArray;
};

export const filterByOnlyClinicExercises = (
  clinicExercisesSelected,
  exercisesList
) => {
  if (clinicExercisesSelected === true) {
    return exercisesList.filter(result => result.isGroupExercise === true);
  } else {
    return exercisesList;
  }
};

export default filterExercises;
